import { css } from "styled-components";

const PAGE_WIDTH = css`
  width: min(100%, 1320px);
`;

export { PAGE_WIDTH };
